import { traduzCategoria } from "../../util/telemetryParser";

export default function TelemetryList({ data }) {
  return (
    <table className="telemetry-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Trem</th>
          <th>Carro</th>
          <th>Categoria</th>
          <th>Parâmetro</th>
          <th>Valor</th>
          {/* <th>Message ID</th> */}
          {/* <th>Batch ID</th> */}
          {/* <th>Publisher</th> */}
          <th>Horário CORE</th>
          <th>Criado no banco</th>
        </tr>
      </thead>

      <tbody>
        {data.map(row => (
          <tr key={`${row.id}-${row.messageTimestamp}-${row.parameterId}-${row.carro}`}>
            <td>{row.id}</td>
            <td>{row.tremNome}</td>
            <td>{row.carro}</td>
            <td>{traduzCategoria(row.category)}</td>
            <td>
              {row.parameterName
                ? `${row.parameterId} - ${row.parameterName}`
                : row.parameterId}
            </td>
            <td>{row.parameterValue}</td>
            {/* <td>{row.messageId}</td> */}
            {/* <td>{row.batchId}</td> */}
            {/* <td>{row.publisherId}</td> */}

            <td>
              {new Date(Number(row.messageTimestamp))
                .toLocaleString("pt-BR")}
            </td>

            <td>
              {new Date(row.createdAt + "Z")
                .toLocaleString("pt-BR")}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}